module.exports = __webpack_public_path__ + "static/media/logo.ccd0e766.png";